import { render } from "./ConceptFormModal.vue?vue&type=template&id=07eddff6"
import script from "./ConceptFormModal.vue?vue&type=script&lang=js"
export * from "./ConceptFormModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__